import styled from 'styled-components'
import theme from 'theme_'

export const TooltipContainer = styled.div`
  position: relative;
`

export const TooltipBlock = styled.div<{ $fullWidth?: boolean }>`
  position: relative;
  width: ${(p) => (p.$fullWidth ? '100%' : '80%')};
  margin: 0 auto;
  padding: 10px;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  max-width: 450px;

  @media ${theme.devices.tablet} {
    margin-bottom: 10px;
    width: 100%;
  }
`
